import { render, staticRenderFns } from "./BatchPathologists.vue?vue&type=template&id=17f9aa19&scoped=true&"
import script from "./BatchPathologists.vue?vue&type=script&lang=js&"
export * from "./BatchPathologists.vue?vue&type=script&lang=js&"
import style0 from "./BatchPathologists.vue?vue&type=style&index=0&id=17f9aa19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f9aa19",
  null
  
)

export default component.exports